<template>
    <div>
        <div class="d-flex flex-column min-vh-100">
            <div class="flex-grow-1 d-flex flex-column">
                <nuxt />
            </div>
            <Footer :footer-links="footerLinks" />
        </div>
        <PortalTarget name="modal" />
    </div>
</template>

<script>
import Base from './base';
import Footer from 'frontend-resources/components/Footer/Footer';

export default {
    components: { Footer },
    extends: Base,
};
</script>
